export const title = ['Эту квартиру сдают без депозита!', 'Как это работает?'];

export const advsList = [
  'При заключении договора не нужно платить депозит',
  'Вместо депозита подписка на Циан за 990₽ в месяц',
  'Квартира сдается официально',
  'Оплата аренды онлайн',
];
